export const ToastLocations = {
  Standard: 'ToastsLocation',
  Studio: 'ToastsLocationStudio',
  StudioDrawer: 'ToastsLocationStudioDrawer',
  CampaignEditorForTemplateEditor: 'ToastsLocationCampaignEditorForTemplateEditor',
} as const;
